import {
  ADD_NEW_CAMPAGIN_FAILED,
  ADD_NEW_CAMPAGIN_REQUEST,
  ADD_NEW_CAMPAGIN_SUCCESS,
  CJSC_EXPORT_TO_CSV_FAILED,
  CJSC_EXPORT_TO_CSV_REQUEST,
  CJSC_EXPORT_TO_CSV_SUCCESS,
  CLEAR_CALL,
  DELETE_CAMPAGIN_FAILED,
  DELETE_CAMPAGIN_REQUEST,
  DELETE_CAMPAGIN_SUCCESS,
  PAUSE_CAMPAIGN_FAILED,
  PAUSE_CAMPAIGN_REQUEST,
  PAUSE_CAMPAIGN_SUCCESS,
  RESUME_CAMPAIGN_FAILED,
  RESUME_CAMPAIGN_REQUEST,
  RESUME_CAMPAIGN_SUCCESS,
  GET_ALL_CAMAGINS_FAILED,
  GET_ALL_CAMAGINS_REQUEST,
  GET_ALL_CAMAGINS_SUCCESS,
  GET_MULITPLE_CJSCID_LIST_FAILED,
  GET_MULITPLE_CJSCID_LIST_REQUEST,
  GET_MULITPLE_CJSCID_LIST_SUCCESS,
  SORT_BY_DATE,
  UPDATE_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN_REQUEST,
  UPDATE_CAMPAIGN_SUCCESS,
} from "../Actions/CampaignsActions";

const initialState = {
  loading: false,
  campaigns: [],
  dailyLimitExceeded: false,
  monthlyLimitExceeded: false,
  success: false,
  cjsids_dropdown: [],
  cjsids_dropdown_loader: false,
};

export const CampaignsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_CAMAGINS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_CAMAGINS_SUCCESS:
      return {
        ...state,
        loading: false,
        campaigns: action.payload.campaigns,
        dailyLimitExceeded: action.payload.dailyLimitExceeded,
        monthlyLimitExceeded: action.payload.monthlyLimitExceeded,
        success: false,
      };
    case GET_ALL_CAMAGINS_FAILED:
      return {
        ...state,
        loading: false,
        campaigns: action.payload,
      };
    case ADD_NEW_CAMPAGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_CAMPAGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case ADD_NEW_CAMPAGIN_FAILED:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case DELETE_CAMPAGIN_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case DELETE_CAMPAGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case DELETE_CAMPAGIN_FAILED:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case PAUSE_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case PAUSE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case PAUSE_CAMPAIGN_FAILED:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
      case RESUME_CAMPAIGN_REQUEST:
        return {
          ...state,
          loading: false,
        };
      case RESUME_CAMPAIGN_SUCCESS:
        return {
          ...state,
          loading: false,
          success: action.payload,
        };
      case RESUME_CAMPAIGN_FAILED:
        return {
          ...state,
          loading: false,
          success: action.payload,
        };
    case SORT_BY_DATE:
      const sortedArray = state.campaigns.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      return {
        ...state,
        data: sortedArray,
      };
    case CLEAR_CALL:
      return {
        ...state,
        success: false,
      };
    case GET_MULITPLE_CJSCID_LIST_REQUEST:
      return {
        ...state,
        cjsids_dropdown_loader: true,
      };
    case GET_MULITPLE_CJSCID_LIST_SUCCESS:
      return {
        ...state,
        cjsids_dropdown_loader: false,
        cjsids_dropdown: action.payload,
      };
    case GET_MULITPLE_CJSCID_LIST_FAILED:
      return {
        ...state,
        cjsids_dropdown_loader: false,
      };
    case CJSC_EXPORT_TO_CSV_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case CJSC_EXPORT_TO_CSV_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case CJSC_EXPORT_TO_CSV_FAILED:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case UPDATE_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    case UPDATE_CAMPAIGN_FAILED:
      return {
        ...state,
        loading: false,
        success: action.payload,
      };
    default:
      return state;
  }
};
